import pr_c_01 from './pr_c_01.jpg'
import pr_c_02 from './pr_c_02.jpg'
import pr_c_03 from './pr_c_03.jpg'
import pr_c_04 from './pr_c_04.jpg'
import pr_c_05 from './pr_c_05.jpg'
import pr_c_06 from './pr_c_06.jpg'
import pr_c_07 from './pr_c_07.jpg'
import pr_c_08 from './pr_c_08.jpg'
import pr_c_09 from './pr_c_09.jpg'
import pr_c_10 from './pr_c_10.jpg'
import pr_c_11 from './pr_c_11.jpg'
import pr_c_12 from './pr_c_12.jpg'
import pr_c_13 from './pr_c_13.jpg'
import pr_c_14 from './pr_c_14.jpg'
import pr_c_15 from './pr_c_15.jpg'
import pr_c_16 from './pr_c_16.jpg'
import pr_c_17 from './pr_c_17.jpg'
import pr_c_18 from './pr_c_18.jpg'
import pr_c_19 from './pr_c_19.jpg'
import pr_c_20 from './pr_c_20.jpg'
import pr_c_21 from './pr_c_21.jpg'
import pr_c_22 from './pr_c_22.jpg'
import pr_c_23 from './pr_c_23.jpg'
import pr_c_24 from './pr_c_24.jpg'
import pr_c_25 from './pr_c_25.jpg'
import pr_c_26 from './pr_c_26.jpg'
import pr_c_27 from './pr_c_27.jpg'
import pr_c_28 from './pr_c_28.jpg'
import pr_c_29 from './pr_c_29.jpg'
import pr_c_30 from './pr_c_30.jpg'

const imgs = {
  G1: pr_c_01,
  G2: pr_c_02,
  G3: pr_c_03,
  G4: pr_c_04,
  G5: pr_c_05,
  G6: pr_c_06,
  G7: pr_c_07,
  G8: pr_c_08,
  G9: pr_c_09,
  G10: pr_c_10,
  G11: pr_c_11,
  G12: pr_c_12,
  G13: pr_c_13,
  G14: pr_c_14,
  G15: pr_c_15,
  G16: pr_c_16,
  G17: pr_c_17,
  G18: pr_c_18,
  G19: pr_c_19,
  G20: pr_c_20,
  G21: pr_c_21,
  G22: pr_c_22,
  G23: pr_c_23,
  G24: pr_c_24,
  G25: pr_c_25,
  G26: pr_c_26,
  G27: pr_c_27,
  G28: pr_c_28,
  G29: pr_c_29,
  G30: pr_c_30,
}

export default imgs